"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styles = require("@material-ui/core/styles");

var _Accordion = _interopRequireDefault(require("@material-ui/core/Accordion"));

var _AccordionSummary = _interopRequireDefault(require("@material-ui/core/AccordionSummary"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Add = _interopRequireDefault(require("@material-ui/icons/Add"));

var _Remove = _interopRequireDefault(require("@material-ui/icons/Remove"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Tooltip = _interopRequireDefault(require("@material-ui/core/Tooltip"));

var _constants = require("../../constants");

var _Headings = require("../Headings");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const StyledCollapsiblePanel = (0, _styles.withStyles)({
  root: {
    borderRadius: '10px !important',
    border: `1px solid ${_constants.colours.mediumGrey}`,
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0
    },
    '&:before': {
      display: 'none'
    },
    '&$expanded': {
      margin: 'auto'
    }
  },
  expanded: {
    borderBottom: `1px solid ${_constants.colours.mediumGrey}`
  }
})(_Accordion.default);
const CollapsiblePanelHeader = (0, _styles.withStyles)({
  root: {
    backgroundColor: `${_constants.colours.white}`,
    marginBottom: 0,
    minHeight: 50,
    padding: '0 15px 0 20px',
    borderRadius: 8,
    '&$expanded': {
      borderBottom: `1px solid ${_constants.colours.tabsBottomBorder}`,
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      minHeight: 50
    }
  },
  content: {
    margin: '0',
    padding: '15px 20px 15px 0px',
    color: `${_constants.colours.font}`,
    borderRight: `1px solid ${_constants.colours.tabsBottomBorder}`,
    display: 'block',
    minHeight: 50,
    width: '100px',
    boxSizing: 'border-box',
    cursor: 'default',
    '&$expanded': {
      cursor: 'default',
      margin: '0',
      display: 'block',
      minHeight: 50
    }
  },
  expanded: {},
  expandIcon: {
    padding: 0
  }
})(_AccordionSummary.default);
const CollapsiblePanelDetails = _styledComponents.default.div`
	padding: ${props => props.slim ? '0' : '0 20px 20px'};
`;
const Wrapper = _styledComponents.default.div`
	width: 50px;
	height: 50px;
	margin: 0;
	padding: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	box-sizing: border-box;
`;

const CollapsiblePanel = ({
  title,
  children,
  defaultExpanded,
  expanded,
  truncateTitle,
  slim,
  ...otherProps
}) => {
  const [expandedState, setExpanded] = (0, _react.useState)(expanded !== null ? expanded : defaultExpanded);
  (0, _react.useEffect)(() => {
    if (expanded !== null) {
      setExpanded(expanded);
    }
  }, [expanded]);
  const panelTitle = truncateTitle ? /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    title: title
  }, /*#__PURE__*/_react.default.createElement(_Headings.Subtitle2, {
    noWrap: truncateTitle
  }, title)) : /*#__PURE__*/_react.default.createElement(_Headings.Subtitle2, {
    noWrap: truncateTitle
  }, title);
  return /*#__PURE__*/_react.default.createElement(StyledCollapsiblePanel, _extends({}, otherProps, {
    expanded: expandedState
  }), /*#__PURE__*/_react.default.createElement(CollapsiblePanelHeader, {
    expandIcon: /*#__PURE__*/_react.default.createElement(Wrapper, {
      className: "toggleButton"
    }, expandedState ? /*#__PURE__*/_react.default.createElement(_Remove.default, null) : /*#__PURE__*/_react.default.createElement(_Add.default, null)),
    onClick: expanded === null ? () => {
      setExpanded(!expandedState);
    } : null
  }, panelTitle), /*#__PURE__*/_react.default.createElement(CollapsiblePanelDetails, {
    slim: slim
  }, children));
};

CollapsiblePanel.propTypes = {
  title: _propTypes.default.node,
  defaultExpanded: _propTypes.default.bool,
  expanded: _propTypes.default.bool
};
CollapsiblePanel.defaultProps = {
  title: '',
  defaultExpanded: false,
  expanded: null
};
var _default = CollapsiblePanel;
exports.default = _default;